import { apiFetch, getAuthHeaders } from '../../services/http';

export type ModuleBadgeStatus = {
  status: 'manual' | 'automated' | 'none';
  count: number;
  detail: string;
};

export type NavigationStatusResponse = {
  success: boolean;
  tenantId: string;
  modules: {
    tasks: ModuleBadgeStatus;
    conversations: ModuleBadgeStatus;
    schedules: ModuleBadgeStatus;
    incidents: ModuleBadgeStatus;
    expense_approvals: ModuleBadgeStatus;
    agents: ModuleBadgeStatus;
    deploy_requests?: ModuleBadgeStatus;
    channels?: ModuleBadgeStatus;
  };
};

export const navigationApi = {
  getStatus: (token: string) =>
    apiFetch<NavigationStatusResponse>('/v1/app/navigation/status', {
      headers: getAuthHeaders(token),
    }),
};
